export const environment = {
	production: true,
	appCode: 'Mortain-admin',
	appVersion: '1',
	languages: ['en', 'fr'],
	appName: 'Mortain',
	login: {
		redirection: [''],
	},
	logout: {
		redirection: ['session', 'sign-in'],
	},
	api: {
		uri: 'https://api.mortain.appymax.com/v1',
		adminPath: '/admin',
	},
	images: {
		uri: 'https://s3.appymax.com/gergovie/',
	},
	plugins: {
		quickForm: {
			enabled: true,
		},
	},
};
